// import { useEffect, useState } from "react";
// import sharedEquityLoanData from "../sharedequityloan.json"; // Adjust the path if necessary

// const useSharedEquityLoanData = () => {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     setData(sharedEquityLoanData);
//   }, []);

//   return data;
// };

// export default useSharedEquityLoanData;

import { useEffect, useState } from "react";

const useSharedEquityLoanData = () => {
  const jsonPath = process.env.REACT_APP_CDN + "dscrheloc/jsons/dscrheloc.json";
  const [sharedEquityLoanData, setSharedEquityLoanData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(jsonPath);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonData = await response.json();
 
        setSharedEquityLoanData(jsonData);
      } catch (err) {
        console.error("Error Fetching Shared Equity Loan JSON data", err);
      }
    };
 
    fetchData();
  }, [jsonPath]);

  return sharedEquityLoanData;
};

export default useSharedEquityLoanData;


// import { useEffect, useState } from "react";

// const useRefinancePageData = () => {
//   const jsonPath = process.env.REACT_APP_CDN + "refinance/jsons/refinancePage.json";
//   const [refinancePageData, setRefinancePageData] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const data = await fetch(jsonPath);
//         const jsonData = await data.json();
//         setRefinancePageData(jsonData);
//       } catch (err) {
//         console.log("Error Fetching Refinance Json data", err);
//       }
//     };

//     fetchData();
//   }, [jsonPath]); 

//   return refinancePageData;
// };

// export default useRefinancePageData;
